






















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class EditIcon extends Vue {
  @Prop({ default: '16' }) readonly width?: string;
  @Prop({ default: '16' }) readonly height?: string;
  @Prop({ default: '#000' }) readonly fill?: string;
}
